import React from 'react';
import { DollarSign, CreditCard } from 'lucide-react';

/**
 * Компонент настроек налогов и комиссий
 */
const TaxesAndFeesSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className={`p-4 rounded-lg border ${formData.includeTaxes ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-100 dark:border-amber-800' : 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700'}`}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
          <DollarSign className="w-5 h-5 mr-2 text-amber-500" />
          Налоги
        </h3>
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeTaxes"
            checked={formData.includeTaxes}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать налоги
          </span>
        </label>
      </div>

      {formData.includeTaxes && (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-1">
          <div>
            <label htmlFor="taxRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Ставка НДФЛ (%)
            </label>
            <div className="relative">
              <input
                type="text"
                id="taxRate"
                name="taxRate"
                value={formData.taxRate}
                onChange={handleInputChange}
                className={`form-input w-full ${errors.taxRate ? 'input-error' : ''}`}
                placeholder="Введите ставку"
              />
              <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
                %
              </span>
            </div>
            {errors.taxRate && (
              <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                {errors.taxRate}
              </p>
            )}
          </div>

          <div className="h-full flex items-center">
            <p className="text-xs text-amber-600 dark:text-amber-400">
              {!formData.useIIS && <span>Стандартная ставка НДФЛ в России составляет 13% от прибыли.</span>}
              {formData.useIIS && formData.iisType === 'taxDeduction' && <span>При использовании ИИС типа А вы получаете налоговый вычет в размере 13% от взносов до 400 000 ₽ в год.</span>}
              {formData.useIIS && formData.iisType === 'taxFree' && <span>При использовании ИИС типа Б весь доход от инвестиций освобождается от НДФЛ.</span>}
            </p>
          </div>
        </div>
      )}

      {/* Комиссии */}
      <div className={`mt-4 p-4 rounded-lg border ${formData.includeFees ? 'bg-orange-50 dark:bg-orange-900/20 border-orange-100 dark:border-orange-800' : 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-700'}`}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-base font-medium text-gray-900 dark:text-white flex items-center">
            <CreditCard className="w-5 h-5 mr-2 text-orange-500" />
            Комиссии
          </h3>
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeFees"
              checked={formData.includeFees}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать комиссии
            </span>
          </label>
        </div>

        {formData.includeFees && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label htmlFor="brokerFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Комиссия брокера (%)
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="brokerFee"
                  name="brokerFee"
                  value={formData.brokerFee}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.brokerFee ? 'input-error' : ''}`}
                  placeholder="Введите комиссию"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
                  %
                </span>
              </div>
              {errors.brokerFee && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.brokerFee}
                </p>
              )}
            </div>

            <div>
              <label htmlFor="managementFee" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Комиссия управления (%)
              </label>
              <div className="relative">
                <input
                  type="text"
                  id="managementFee"
                  name="managementFee"
                  value={formData.managementFee}
                  onChange={handleInputChange}
                  className={`form-input w-full ${errors.managementFee ? 'input-error' : ''}`}
                  placeholder="Введите комиссию"
                />
                <span className="absolute inset-y-0 right-3 flex items-center text-gray-500 pointer-events-none">
                  %
                </span>
              </div>
              {errors.managementFee && (
                <p className="mt-1 text-xs text-red-500 dark:text-red-400">
                  {errors.managementFee}
                </p>
              )}
            </div>

            <div className="col-span-1 sm:col-span-2">
              <p className="text-xs text-orange-600 dark:text-orange-400">
                <strong>Комиссия брокера</strong> взимается за совершение сделок по пополнению и снятию средств. 
                <strong> Комиссия управления</strong> (для ДУ, ПИФов и ETF) взимается ежегодно от суммы активов.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaxesAndFeesSection;